import styled from 'styled-components'
import { Colors, Spacing } from 'styles'

export const Container = styled.div`
  width: 100%;
  position: relative;
`

export const SummaryContainer = styled.div`
  width: 100%;
  background-color: ${Colors.GREY[100]};
  padding: 20px;
  border-radius: ${Spacing.SCALE_16}px;
  box-sizing: border-box;
  display: flex;
  gap: 10px;
`

export const SummaryText = styled.p`
  font-weight: 300;
  font-size: 1rem;
  color: ${Colors.TEXT_DARK};
  font-family: Inter;
  margin: 0;
`

export const LoadingContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: ${Colors.GREY[100]}CC;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${Spacing.SCALE_16}px;
`
